import { render, staticRenderFns } from "./ShowEventBase.vue?vue&type=template&id=40fc654e&scoped=true&"
import script from "./ShowEventBase.vue?vue&type=script&lang=ts&"
export * from "./ShowEventBase.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventBase.vue?vue&type=style&index=0&id=40fc654e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc654e",
  null
  
)

export default component.exports